module.exports = __webpack_public_path__ + "static/media/MoshiWaves.ab404e39.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Home/MoshiWaves.mp4
// module id = 143
// module chunks = 0